import { isAndroidWebView } from "../global-components/src/utils/platform";
import { PACOCA_URL } from "../global-components/src/utils/vars";

export function getPlatform(): 'MacOS' | 'Windows' | 'Android' | 'iOS' | 'other' {
  const ua = navigator.userAgent || '';

  if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window)) return 'iOS'; // iOS ainda não tem download
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(ua)) return 'MacOS';
  if (/Win32|Win64|Windows|WinCE/.test(ua)) return 'Windows';
  if (/Android/.test(ua)) return 'Android';

  return 'other';
}

export function shouldHideMenus(): boolean {
  const value = new URLSearchParams(window.location.search).get("hideMenu");
  return value === "1" || value === "true";
}

export function isWebView(): boolean {
  const ua = navigator.userAgent || '';

  // Electron é considerado WebView
  if (/Electron/.test(ua)) return true;

  // iOS WebView
  const isiOS = /iPad|iPhone|iPod/.test(ua) && !('MSStream' in window);
  if (isiOS) {
    const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
    const standalone = 'standalone' in navigator ? (navigator as any).standalone : false;
    if (!isSafari && !standalone) return true;
  } 

  // Android WebView
  const isAndroid = /Android/.test(ua);
  if (isAndroid) {
    // wv ou Version/x.y indica WebView
    if (/wv/.test(ua) || /Version\/[\d.]+/.test(ua)) return true;
  }

  return false;
}

export function getAppVersion(){
  if(getPlatform() == "Android" || getPlatform() == "iOS")
    return (window as any)?.BUILD_NUMBER && !isNaN(Number((window as any)?.BUILD_NUMBER)) ? Number((window as any)?.BUILD_NUMBER) : null;

  return 1;
}

export function isLiteApp(): boolean {
  const isLite = (window as any)?.IS_LITE;
  return isLite === true || isLite === "true";
}

export function getAppLastVersion(){
  if(getPlatform() == "Android")
    return isLiteApp() ? 152 : 157;

  if(getPlatform() == "iOS")
    return 21;

  if(getPlatform() == "Windows")
    return 0;
  
  return 2;
}

export function getNativeNavigationHeight(){
  return (window as any)?.NAVIGATION_BAR_HEIGHT && !isNaN(Number((window as any)?.NAVIGATION_BAR_HEIGHT)) ? Number((window as any)?.NAVIGATION_BAR_HEIGHT) : null;
}

export function getNativeStatusBarHeight(){
  return (window as any)?.STATUS_BAR_HEIGHT && !isNaN(Number((window as any)?.STATUS_BAR_HEIGHT)) ? Number((window as any)?.STATUS_BAR_HEIGHT) : null;
}

export function getNativeKeyboardHeight(){
  return (window as any)?.KEYBOARD_HEIGHT && !isNaN(Number((window as any)?.KEYBOARD_HEIGHT)) ? Number((window as any)?.KEYBOARD_HEIGHT) : null;
}

export function isNewApp(){
  const buildVersion = getAppVersion();
  return buildVersion && buildVersion >= 8;
}

export function isNewAppAndroid(){
  const buildVersion = getAppVersion();
  return buildVersion && buildVersion >= 94;
}

export function hasNativeMic(){
  if(!isWebView() || (getPlatform() != "Android" && getPlatform() != "iOS")) return false;
  const buildVersion = getAppVersion();
  // || (getPlatform() == "iOS" && buildVersion >= 8)
  return buildVersion && ((getPlatform() == "Android" && buildVersion >= 109));
}

export function isIOSWebView(): boolean {
  const ua = window.navigator.userAgent;
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);

  // "standalone" existe só em iOS Safari
  const standalone = 'standalone' in navigator ? (navigator as any).standalone : false;

  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window) && !isSafari && !standalone;
}

export function removeToNativeiOS(id_user: number | undefined): boolean {
  return (isIOSWebView() && id_user == 5401) || (isIOSWebView() && !id_user);
}

export function getStore(): "Play Store" | "Apple Store" | "Paçoca Store" | boolean {
  if(getPlatform() == "Android") return "Play Store";
  if(getPlatform() == "Windows") return "Paçoca Store";
  if(getPlatform() == "MacOS") return "Paçoca Store";
  if(getPlatform() == "iOS") return "Apple Store";
  return false
}

export function getLinkStore() {
  if(getPlatform() == "Android") {
    const packageName = isLiteApp() ? "com.joaoalves.pacoca.lite" : "com.joaoalves.pacoca";
    return `https://play.google.com/store/apps/details?id=${packageName}`;
  }
  if(getPlatform() == "Windows") return `${PACOCA_URL}/download?p=windows`;
  if(getPlatform() == "iOS") return `https://apps.apple.com/us/app/pa%C3%A7oca/id6742334455`;
  if(getPlatform() == "MacOS") return `${PACOCA_URL}/download?p=macos`;
  return ""
}

export function hasNewVersion(){
  if(!isWebView()) return false;

  const version = getAppVersion();
  const platform = getPlatform();
  if(!version) return false;

  if(platform == "Android" || platform == "iOS" || platform == "Windows") return version < getAppLastVersion();
  return false;
}

export function isDesktop(){
  return getPlatform() != "Android" && getPlatform() != "iOS"
}